import objectPath from 'object-path'

const getters = {
  getField: state => target => objectPath.get(state, target),
  isLoading: state => state.isLoading,
  form: state => state.form,
  filials: state => state.filials,
  getFormForCreate: (state) => {
    const {
      filialId,
      country: {
        slug: countryId
      },
      city: {
        slug: cityId
      },
      startDate,
      budget,
      name,
      surname,
      email,
      phone,
      comment,
    } = state.form

    return {
      ...state.form.rooms[0],
      filialId,
      countryId,
      cityId,
      startDate,
      name,
      surname,
      email,
      phone,
      comment,
      budget
    }
  }
}

export default getters